module.exports = __webpack_public_path__ + "assets/1f8b4789bfd850774cf81afc408fb5b9.png";